
import { defineComponent } from "vue";
import { getCurrentUser } from "@/utils/index";
import { getDashboardECPWelcomeData } from "@/api/dashboard";
import SeqNoticeCard from "@/components/dashboard/sequence/SeqNoticeCard.vue";

export default defineComponent({
  name: "PMAReminderNotice",
  components: {
    SeqNoticeCard,
  },
  data() {
    return {
      userUsid: "",
      isShowPMAWarning: false,
      unilevelMaintenancePromptMessage1: "",
      unilevelMaintenancePromptMessage2: "",
      extraPromptMessage: "",
      pmaReminderButtons: [
        { label: "Complete your maintenance NOW", href: "#/estore", color: "primary" },
      ],
    };
  },
  mounted() {
    const user = getCurrentUser() || {};
    this.userUsid = String(user.usid || "");
    this.loadPMAReminder();
  },
  methods: {
    async loadPMAReminder() {
      try {
        const response = await getDashboardECPWelcomeData();
        const message = response?.data?.unilevelMaintenancePromptMessage || "";

        this.unilevelMaintenancePromptMessage1 = message.split(
          "complete your maintenance NOW"
        )[0];
        this.unilevelMaintenancePromptMessage2 =
          message.split("complete your maintenance NOW")[1] || "";
        this.extraPromptMessage =
          response?.data?.unilevelMaintenancePromptMessage2 || "";

        if (message) {
          this.isShowPMAWarning =
            message.includes("To continue") && !!response?.data?.is10DaysLeftForPMA;
        } else {
          this.isShowPMAWarning = false;
        }
      } catch (error) {
        console.error("Failed to load PMA reminder:", error);
        this.isShowPMAWarning = false;
      }
    },
  },
});
